import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/logo.png'


const _hoisted_1 = { class: "terms-privacy" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle1 q-mt-md q-mb-none" }, [
  /*#__PURE__*/_createTextVNode(" To save a copy for your records, click "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://private-footprint-prod.s3.ca-central-1.amazonaws.com/resources/docs/client/Terms+%26+Privacy.pdf",
    target: "_blank"
  }, "here"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_terms_and_conditions = _resolveComponent("terms-and-conditions")!
  const _component_privacy_policy = _resolveComponent("privacy-policy")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Terms and Conditions and Privacy Policy",
    size: "md",
    unclosable: "",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        task: _ctx.task,
        label: "I have read and agree to the Terms and Conditions and Privacy Policy",
        color: "positive",
        onClick: _ctx.agree
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_scroll_area, {
        visible: "",
        style: {"height":"500px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_terms_and_conditions),
            _createVNode(_component_privacy_policy, { class: "q-mt-xl" })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      _hoisted_3
    ]),
    _: 1
  }, 512))
}